// frontend/src/components/SmartDashboardRedirect.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Dashboard from '@/pages/Dashboard';

const SmartDashboardRedirect: React.FC = () => {
  const { user } = useAuth();

  // Smart redirect based on user role
  const getRedirectPath = () => {
    switch (user?.role) {
      case "user": // Customers go to new account layout
        return "/account";
      case "admin":
      case "super_admin":
      case "provider":
      default:
        // Everyone else gets the traditional dashboard
        return null; // Return null to render Dashboard component
    }
  };

  const redirectPath = getRedirectPath();

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  // Render traditional dashboard for non-customers
  return <Dashboard />;
};

export default SmartDashboardRedirect;